<template>
  <div class='surveys-view mt-3'>
    <quill-editor
      v-model='v$.chemicalInventoryReport.body.$model'
      value='Hello, World!'>
    </quill-editor>

    <div class='d-flex justify-content-end'>
      <base-button
        :disabled='v$.$invalid'
        class='w-25'
        @click='save()'>
        {{ chemicalInventoryReport._id ? 'Atualizar' : 'Cadastrar' }}
      </base-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import useVuelidate from '@vuelidate/core'
import { required } from '@/utils/validators'

export default {
  name: 'ChemicalInventoryReport',
  data() {
    return {
      contentHtml: '',
    }
  },
  setup() {
    return { v$: useVuelidate() }
  },
  components: {},
  validations: {
    chemicalInventoryReport: {
      body: { required }
    }
  },
  computed: {
    ...mapGetters('chemicalInventoryReport', {
      chemicalInventoryReport: 'getChemicalInventoryReport'
    })
  },
  methods: {
    ...mapActions('chemicalInventoryReport', {
      handleCreateChemicalInventoryReport: 'handleCreateChemicalInventoryReport',
      handleGetChemicalInventoryReport: 'handleGetChemicalInventoryReport',
      handleUpdateChemicalInventoryReport: 'handleUpdateChemicalInventoryReport'
    }),
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb',
    }),
    async save() {
      let response
      if (this.chemicalInventoryReport._id) {
        response = await this.handleUpdateChemicalInventoryReport()
      } else {
        response = await this.handleCreateChemicalInventoryReport()
      }

      let message = response.data.message
      let variant = 'danger'

      if (response.status === 201 || response.status === 200) {
        message = response.data.message
        variant = 'success'
      }

      this.$bvToast.toast(message, {
        title: 'Atenção',
        variant: variant,
        toaster: 'b-toaster-top-center',
        autoHideDelay: 5000
      })
    }
  },
  async created() {
    await this.handleGetChemicalInventoryReport()
    const breadcrumb = {
      page: 'Relatório de Inventário Químico',
      subPage: {
        name: 'Relatório de Inventário Químico',
        active: true
      },
      tabs: []
    }
    this.setBreadcrumb(breadcrumb)
  }
}
</script>

<style lang='scss' scoped>
.surveys-view {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
